<template>
    <div
        class="create-asset__input input input--md input--grey clearfix"
        :class="rounded ? 'rounded' : ''"
    >
        <label :for="name" class="label">
            {{ label }}
            <span>(readonly - {{ description }})</span>
        </label>

        <div>
            <Component
                :is="tag"
                :id="name"
                ref="input"
                class="inactive"
                :name="name"
                enabled="false"
                readonly="true"
                :value.prop="value"
                type="text"
                autocomplete="off"
            />
        </div>
    </div>
</template>

<script>
export default {
    props: {
        tag: {
            type: String,
            default: 'input',
        },
        name: {
            type: String,
            required: true,
        },
        value: {
            required: true,
        },
        label: {
            type: String,
            required: true,
        },
        description: {
            type: String,
            required: true,
        },
        rounded: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        wrapClasses() {
            const classes = [];

            if (this.rounded) {
                classes.push('input--rounded');
            }

            return classes;
        },
    },
    mounted() {
        if (this.tag === 'textarea') {
            this.checkIfScrollable(this.$refs.input);
        }
    },
    methods: {
        checkIfScrollable(t) {
            if (t.clientHeight >= t.scrollHeight) {
                if (t.classList.contains('scrollable')) {
                    t.classList.remove('scrollable');
                }
            } else {
                if (!t.classList.contains('scrollable')) {
                    t.classList.add('scrollable');
                }
            }
        },
    },
};
</script>
<style scoped lang="scss">
.label {
    margin-bottom: 0.5em;
}

.inactive {
    background-color: #ececec;
}

.rounded {
    input,
    select {
        border-radius: 0.5em;
    }
}
</style>
